import { render, staticRenderFns } from "./rechargelist.vue?vue&type=template&id=350a6000&scoped=true"
import script from "./rechargelist.vue?vue&type=script&lang=js"
export * from "./rechargelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a6000",
  null
  
)

export default component.exports